export default "__VITE_ASSET__UptIYjF5__"